import React from "react"
import {
  FooterDiv,
  LeftSection,
  RightSection,
  FooterLink,
  Separator,
  RightText,
} from "./styles"
import { isApplicationMode, isLateralMode } from "utils/productUtils"
import Translate from "components/Translate/container"
import { connect } from "react-redux"

export class Footer extends React.Component {
  render() {
    const { topMargin } = this.props

    return isApplicationMode() ? (
      <FooterDiv topMargin={topMargin}>
        <React.Fragment>
          <LeftSection>
            &copy;{new Date().getFullYear()} Rare Recruitment Ltd.
          </LeftSection>
          <RightSection>
            {!isLateralMode() && (
              <React.Fragment>
                <FooterLink
                  rightMargin
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://candidats.io/faq"
                >
                  <Translate>FAQs</Translate>
                </FooterLink>
                <Separator>|</Separator>
              </React.Fragment>
            )}
            <FooterLink
              leftMargin
              rightMargin
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.rarerecruitment.co.uk/accessibility-policy"
            >
              <Translate>Accessibility Policy</Translate>
            </FooterLink>
            <Separator>|</Separator>
            <FooterLink
              leftMargin
              rightMargin
              style={{ marginRight: "30px" }}
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.rarerecruitment.co.uk/privacy-policy"
            >
              <Translate>Privacy Policy</Translate>
            </FooterLink>
            <Separator>|</Separator>
            <RightText>
              <Translate>By using this website you agree to the</Translate>
              &nbsp;
              <FooterLink
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.rarerecruitment.co.uk/website-terms-of-use"
              >
                <Translate>Terms Of Use</Translate>
              </FooterLink>
            </RightText>
          </RightSection>
        </React.Fragment>
      </FooterDiv>
    ) : null
  }
}

const mapStateToProps = ({ data }) => ({
  translationMap: data.translationMap,
})

const mapDispatchToProps = dispatch => {}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
